import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { SingleSignOnPage } from '@/routes/single-sign-on/page'

export const SingleSignOn = () => (
  <PageErrorBoundary>
    <SingleSignOnPage />
  </PageErrorBoundary>
)

export default SingleSignOn
